<template>
  <div class="bjtp">
    <!--导航栏-->
    <div>
      <navi></navi>
    </div>
    <el-row :gutter="20" class="qq" v-loading="loading">
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <div class="ulleft">
            <ul class="option_item">
              <li class="li-active" @click="scrollToElement('info')">人物简介</li>
              <li @click="scrollToElement('summary')" v-if="personDetail.summary">个人概述</li>
              <li @click="scrollToElement('skills')" v-if="skills.length > 0">人物属性</li>
              <li
                @click="scrollToElement('social')"
                v-if="phone.length > 0 || email.length > 0 || social.length > 0 || personDetail.dehashed != null"
              >通联身份</li>
              <li @click="scrollToElement('experience')" v-if="experience.length > 0">工作经历</li>
              <li @click="scrollToElement('educational')" v-if="educational.length > 0">教育经历</li>
              <li
                @click="scrollToElement('volunteeringexperiences')"
                v-if="volunteeringexperiences.length > 0"
              >志愿者经历</li>
              <li @click="scrollToElement('courses')" v-if="courses.length > 0">培训经历</li>
              <li @click="scrollToElement('projects')" v-if="projects.length > 0">项目经历</li>
              <li @click="scrollToElement('certifications')" v-if="certifications.length > 0">获得证书</li>
              <li @click="scrollToElement('honors')" v-if="honors.length > 0">获得荣誉</li>
              <li @click="scrollToElement('patents')" v-if="patents.length > 0">专利</li>
              <li @click="scrollToElement('publication')" v-if="publication.length > 0">出版物</li>
              <li @click="scrollToElement('languages')" v-if="languages.length > 0">掌握语言</li>
              <li @click="scrollToElement('endorsors')" v-if="endorsors.length > 0">人脉关系</li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <div
          class="grid-content bg-purple"
          style="margin-top:120px;margin-bottom:70px;border-radius:10px;"
        >
          <div class="option_content">
            <!-- 个人简介 -->
            <div class="info" id="info">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>人物简介</span>
              </div>
              <div class="opct_msg">
                <div class="na_list">
                  <div class="na_img">
                    <img
                      :src="'data:image/png;base64,' + personDetail.imgcode"
                      alt
                      :onerror="defaultImg"
                      :style="{ width: 160 + 'px', height: imgHeight + 'px' }"
                    />
                  </div>
                  <div class="na_message" ref="myDiv">
                    <p :title="personDetail.name">
                      <span style="display:inline-block;">
                        姓名：
                        <span
                          style="font-size: 1.17em;font-weight: bold;"
                          v-html="brightenKeyword(personDetail.name)"
                        ></span>
                      </span>
                    </p>
                    <p>
                      <span>
                        行业：
                        <span
                          class="huaTitle"
                          :title="personDetail.industry"
                          v-html="brightenKeyword(personDetail.industry)"
                        ></span>
                        <span>
                          &nbsp;
                          <span class="huaTitle" v-if="personDetail.ishua == 1">涉华</span>
                        </span>
                      </span>
                    </p>
                    <p :title="personDetail.position">
                      <span>职位：</span>
                      <span v-html="brightenKeyword(personDetail.position)"></span>
                    </p>
                    <p :title="personDetail.address">
                      <span>地址：</span>
                      <span v-html="brightenKeyword(personDetail.address)"></span>
                    </p>
                    <p :title="personDetail.organName">
                      <span style="display:inline-block;">
                        <span>所属机构：</span>
                        <span v-html="brightenKeyword(personDetail.organName)"></span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- summary 个人概述 -->
            <div class="summary" id="summary" style v-if="personDetail.summary">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>个人概述</span>
              </div>
              <div class="opct_msg">
                <div style="text-indent:2rem;" v-html="brightenKeyword(personDetail.summary)"></div>
              </div>
            </div>

            <!-- skills 人物属性 -->
            <div class="skills" id="skills" style v-if="skills.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>人物属性</span>
              </div>
              <div class="opct_msg">
                <div style="display:flex;flex-wrap: wrap;">
                  <div
                    class="huaTitle"
                    style="margin:0 10px 10px 0;"
                    v-for="(item, index) in skills"
                    :key="index"
                    v-html="brightenKeyword(item.name)"
                  ></div>
                </div>
              </div>
            </div>

            <!-- social 通联身份 -->
            <div
              class="social"
              id="social"
              v-if="phone.length > 0 || email.length > 0 || social.length > 0 || personDetail.dehashed != null"
            >
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>通联身份</span>
              </div>
              <div class="opct_msg">
                <div class="na_summary" style="margin-top: 15px">
                  <div v-if="phone.length > 0">
                    <div class="kstop">电话：</div>
                    <div style="padding-left: 20px;margin: 14px 0;">
                      <div v-for="(item, index) in this.phone" :key="index">
                        <span v-if="item.subType == 'work_phone'">
                          <i class="iconfont el-icon-gongzuoxinxi" />
                          {{item.value}}
                        </span>
                        <span
                          v-if="item.subType == 'mobile' || (item.subType == null && item.type == 'mobile')"
                        >
                          <i class="iconfont el-icon-shouji" />
                          {{ item.value }}
                        </span>
                        <span
                          v-if="item.subType == 'phone' || (item.subType == null && item.type == 'phone')"
                        >
                          <i class="iconfont el-icon-24gf-phoneLoudspeaker" />
                          {{ item.value}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="email.length > 0">
                    <div class="kstop">邮箱：</div>
                    <div style="padding-left: 20px;margin: 14px 0;">
                      <div v-for="(  item, index  ) in    this.email   " :key="index">
                        <span v-if="item.subType == 'work'">
                          <i class="iconfont el-icon-gongzuoxinxi" />
                          {{ item.value}}
                        </span>
                        <span v-if="item.subType == 'personal'">
                          <i class="iconfont el-icon-email1" />
                          {{ item.value}}
                        </span>
                        <span v-if="item.subType != 'personal' && item.subType != 'work'">
                          <i class="iconfont el-icon-email1" />
                          {{ item.value}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="social.length > 0">
                    <div class="kstop">社交帐号：</div>
                    <div style="padding-left: 20px;margin: 14px 0;">
                      <div v-for="(   item, index   ) in    this.social   " :key="index">
                        <span v-if="item.type == 'li' || item.type == 'linkedin'">
                          <i class="iconfont el-icon-linkedin"></i>
                          {{returnSocial(item.value) }}
                        </span>
                        <span v-if="item.type == 'fb' || item.type == 'facebook'">
                          <i class="iconfont el-icon-facebook"></i>
                          {{returnSocial(item.value) }}
                        </span>
                        <span v-if="item.type == 'tw' || item.type == 'twitter'">
                          <i class="iconfont el-icon-twitter-square-fill"></i>
                          {{returnSocial(item.value) }}
                        </span>
                        <span v-if="item.type == 'yt' || item.type == 'youtube'">
                          <i class="iconfont el-icon-youtube"></i>
                          {{returnSocial(item.value)}}
                        </span>
                        <span v-if="item.type == 'ig' || item.type == 'instagram'">
                          <i class="iconfont el-icon-instagram"></i>
                          {{returnSocial(item.value) }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="personDetail.dehashed">
                    <div class="kstop">关联信息：</div>
                    <ul>
                      <li
                        style="margin-bottom: 10px;"
                        v-for="(item, index) in dehashed   "
                        :key="index"
                      >
                        <div>
                          <div style="display:flex;" v-if="item.vin">
                            <span style="width:15%;">vin</span>
                            <span>{{item.vin}}</span>
                          </div>
                          <div style="display:flex;" v-if="item.name">
                            <span style="width:15%;">name</span>
                            <span>{{item.name}}</span>
                          </div>
                          <div style="display:flex;" v-if="item.email">
                            <span style="width:15%;">email</span>
                            <span>{{item.email}}</span>
                          </div>
                          <div style="display:flex;" v-if="item.phone">
                            <span style="width:15%;">phone</span>
                            <span>{{item.phone}}</span>
                          </div>
                          <div style="display:flex;" v-if="item.address">
                            <span style="width:15%;">address</span>
                            <span>{{item.address}}</span>
                          </div>
                          <div style="display:flex;" v-if="item.username">
                            <span style="width:15%;">username</span>
                            <span>{{item.username }}</span>
                          </div>
                          <div style="display:flex;" v-if="item.password">
                            <span style="width:15%;">password</span>
                            <span>{{item.password }}</span>
                          </div>
                          <div style="display:flex;" v-if="item.ip_address">
                            <span style="width:15%;">ip_address</span>
                            <span>{{item.ip_address}}</span>
                          </div>
                          <div style="display:flex;" v-if="item.database_name">
                            <span style="width:15%;">database_name</span>
                            <span>{{item.database_name }}</span>
                          </div>
                          <div style="display:flex;" v-if="item.hashed_password">
                            <span style="width:15%;">hashed_password</span>
                            <span>{{item.hashed_password }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- experience 工作经历 -->
            <div class="experience" id="experience" style v-if="experience.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>工作经历</span>
              </div>
              <div class="opct_msg" v-if="personDetail.ishua == 0">
                <ul class="opct_doc">
                  <li v-for="(item, index) in experience" :key="index">
                    <span v-html="brightenKeyword(item.displayText)"></span>
                    <span v-if="item.i18nStartDate|| item.i18nEndDate">,</span>
                    <span>{{ item.i18nStartDate}}</span>
                    <span v-if="item.i18nStartDate|| item.i18nEndDate">~</span>
                    <span>{{ item.i18nEndDate }}</span>
                  </li>
                </ul>
              </div>
              <div class="opct_msg" v-if="personDetail.ishua == 1">
                <div
                  v-for="(item, index) in experience"
                  :key="index"
                  style="display:flex;margin-bottom: 10px;"
                >
                  <div style="color:#a6a6a6;width:18%;">
                    <span>{{ item.i18nStartDate }}</span>
                    &nbsp;-&nbsp;
                    <span>{{ checkExperienceValue(item.i18nEndDate) }}</span>
                  </div>
                  <div style="width:70%;">
                    <span
                      style="display: block;"
                      v-if="item.displayText"
                      v-html="brightenKeyword(item.displayText)"
                    ></span>
                    <span
                      v-if="item.location"
                      style="color:#46c6e6;font-size:13px;display: block;"
                      v-html="brightenKeyword(item.location)"
                    ></span>
                    <span
                      v-if="item.description"
                      style="color:#afb3b4;font-size:12px;display: block;"
                      v-html="brightenKeyword(item.description)"
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- educational 教育经历 -->
            <div class="educational" id="educational" style v-if="educational.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>教育经历</span>
              </div>
              <div class="opct_msg" v-if="personDetail.ishua == 0">
                <ul class="opct_doc">
                  <li v-for="(item, index) in this.educational" :key="index">
                    <span v-html="brightenKeyword(item.schoolName)"></span>
                    <span v-if="item.i18nStartDate|| item.i18nEndDate">,</span>
                    <span>{{ item.i18nStartDate}}</span>
                    <span v-if="item.i18nStartDate|| item.i18nEndDate">~</span>
                    <span>{{ item.i18nEndDate }}</span>
                  </li>
                </ul>
              </div>
              <div class="opct_msg" v-if="personDetail.ishua == 1">
                <ul class="opct_doc">
                  <li
                    v-for="(item, index) in this.educational"
                    :key="index"
                    style="margin-bottom: 10px;"
                  >
                    <span v-html="brightenKeyword(item.schoolName)"></span>
                    <span v-if="item.i18nStartDate|| item.i18nEndDate">,</span>
                    <span>{{ item.i18nStartDate}}</span>
                    <span v-if="item.i18nStartDate|| item.i18nEndDate">~</span>
                    <span>{{ item.i18nEndDate }}</span>
                    <span
                      v-if="item.degreeName"
                      style="color:#46c6e6;font-size:13px;display: block;"
                      v-html="brightenKeyword(item.degreeName)"
                    ></span>
                    <span
                      v-if="item.description"
                      style="color:#afb3b4;font-size:12px;display: block;"
                      v-html="brightenKeyword(item.description)"
                    ></span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- volunteeringexperiences 志愿者经历 -->
            <div
              class="volunteeringexperiences"
              id="volunteeringexperiences"
              style
              v-if="volunteeringexperiences.length > 0"
            >
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>志愿者经历</span>
              </div>
              <div class="opct_msg">
                <div
                  v-for="(item, index) in volunteeringexperiences"
                  :key="index"
                  style="display:flex;margin-bottom:10px;"
                >
                  <div style="color:#a6a6a6;width:20%;">
                    <span>{{ item.i18nStartDate }}</span>
                    &nbsp;-&nbsp;
                    <span>{{ checkExperienceValue(item.i18nEndDate) }}</span>
                  </div>
                  <div style="width:75%;">
                    <span
                      style="display: block;"
                      v-if="item.displayText"
                      v-html="brightenKeyword(item.displayText)"
                    ></span>
                    <span
                      v-if="item.description"
                      style="color:#afb3b4;font-size:12px;display: block;"
                      v-html="brightenKeyword(item.description)"
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- courses 培训经历 -->
            <div class="courses" id="courses" style v-if="courses.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>培训经历</span>
              </div>
              <div class="opct_msg">
                <ul class="opct_doc" style="margin-bottom: 10px;">
                  <li v-for="(item, index) in courses" :key="index">
                    <span v-if="item.displayText">{{ item.displayText }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- projects 项目经历 -->
            <div class="projects" id="projects" style v-if="projects.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>项目经历</span>
              </div>
              <div class="opct_msg">
                <div
                  v-for="(item, index) in projects"
                  :key="index"
                  style="display:flex;margin-bottom:10px;"
                >
                  <div style="color:#a6a6a6;width:20%;">
                    <span>{{ item.i18nStartDate }}</span>
                    &nbsp;-&nbsp;
                    <span>{{ checkExperienceValue(item.i18nEndDate) }}</span>
                  </div>
                  <div style="width:75%;">
                    <span
                      style="display: block;"
                      v-if="item.displayText"
                      v-html="brightenKeyword(item.displayText)"
                    ></span>
                    <span
                      v-if="item.description"
                      style="color:#afb3b4;font-size:12px;display: block;"
                      v-html="brightenKeyword(item.description)"
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- certifications 获得证书 -->
            <div class="certifications" id="certifications" style v-if="certifications.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>获得证书</span>
              </div>
              <div class="opct_msg">
                <div
                  v-for="(item, index) in certifications"
                  :key="index"
                  style="margin-bottom: 10px;"
                >
                  <span v-if="item.displayText" v-html="brightenKeyword(item.displayText)"></span>
                  <span
                    v-if="item.i18nStartDate"
                    style="color:#46c6e6;font-size:13px;display: block;"
                  >Issued {{ item.i18nStartDate }}</span>
                  <span
                    v-if="item.description"
                    style="color:#afb3b4;font-size:12px;display: block;"
                    v-html="brightenKeyword(item.description)"
                  ></span>
                </div>
              </div>
            </div>

            <!-- honors 获得荣誉 -->
            <div class="honors" id="honors" style v-if="honors.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>获得荣誉</span>
              </div>
              <div class="opct_msg">
                <div v-for="(item, index) in honors" :key="index" style="margin-bottom: 10px;">
                  <span v-if="item.displayText" v-html="brightenKeyword(item.displayText)"></span>
                  <span v-if="item.i18nStartDate">({{ item.i18nStartDate }})</span>
                  <br />
                  <span
                    v-if="item.issuer"
                    style="color:#46c6e6;font-size:13px;display: block;"
                  >{{ item.issuer }}</span>
                  <span
                    v-if="item.description"
                    style="color:#afb3b4;font-size:12px;display: block;"
                    v-html="brightenKeyword(item.description)"
                  ></span>
                </div>
              </div>
            </div>

            <!-- patents 专利 -->
            <div class="patents" id="patents" style v-if="patents.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>专利</span>
              </div>
              <div class="opct_msg">
                <div v-for="(item, index) in patents" :key="index" style="margin-bottom: 10px;">
                  <span v-if="item.displayText" v-html="brightenKeyword(item.displayText)"></span>
                  <span v-if="item.i18nStartDate">({{ item.i18nStartDate }})</span>
                  <br />
                  <span
                    v-if="item.issuer"
                    style="color:#46c6e6;font-size:13px;display: block;"
                  >{{ item.issuer }}</span>
                  <span
                    v-if="item.description"
                    style="color:#afb3b4;font-size:12px;display: block;"
                    v-html="brightenKeyword(item.description)"
                  ></span>
                </div>
              </div>
            </div>

            <!-- publication 出版物 -->
            <div class="publication" id="publication" style v-if="publication.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>出版物</span>
              </div>
              <div class="opct_msg">
                <div v-for="(item, index) in publication" :key="index" style="margin-bottom: 10px;">
                  <span v-if="item.displayText" v-html="brightenKeyword(item.displayText)"></span>
                  <span v-if="item.i18nStartDate">({{ item.i18nStartDate }})</span>
                  <br />
                  <span
                    v-if="item.publisher"
                    style="color:#46c6e6;font-size:13px;display: block;"
                  >{{ item.publisher }}</span>
                  <span
                    v-if="item.description"
                    style="color:#afb3b4;font-size:12px;display: block;"
                    v-html="brightenKeyword(item.description)"
                  ></span>
                </div>
              </div>
            </div>

            <!-- languages 掌握语言 -->
            <div class="languages" id="languages" style v-if="languages.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span>掌握语言</span>
              </div>
              <div class="opct_msg">
                <ul class="opct_doc" style="margin-bottom: 10px;">
                  <li v-for="(item, index) in languages" :key="index">
                    <span v-if="item.displayText">{{ item.displayText }}</span>
                    <span
                      v-if="item.description"
                      style="color:#afb3b4;font-size:12px;"
                    >_{{ item.description }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- endorsors 人脉关系 -->
            <div class="endorsors" id="endorsors" style v-if="this.endorsors.length > 0">
              <div class="opct_title">
                <div id="layer_line"></div>
                <span
                  @click="relevanceOneFunction()"
                  :class="{ relevanceOne: this.relevanceOne, relevanceTwo: !this.relevanceOne }"
                >人脉列表</span>
                <span
                  @click="relevanceTwoFunction()"
                  :class="{ relevanceOne: this.relevanceTwo, relevanceTwo: !this.relevanceTwo }"
                >人脉图谱</span>
              </div>
              <div class="opct_msg endorsor" v-show="relevanceOne">
                <div v-for="(item, index) in this.endorsors" :key="index" :title="item.memberurl">
                  <div style="display:flex;justify-content:center;">
                    <img :src="'data:image/png;base64,' + item.imgcode" :onerror="defaultImg" />
                  </div>
                  <div>
                    <span
                      style="display:flex;justify-content:center;font-weight:bold;"
                    >{{ item.name }}</span>
                    <span class="clampThree">{{ item.headline }}</span>
                  </div>
                </div>
              </div>
              <div v-show="relevanceTwo">
                <relevance :detailId="this.personDetail.id"></relevance>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <foot style="position: fixed;left: 0px;bottom: 0px;width: 100%;"></foot>
  </div>
</template>

<script scoped>
import navi from "../components/navi";
import foot from "../components/foot";
import relevance from "../components/relevance";
import { getPersonsByid } from "@/api/persons";
export default {
  name: "rwxq",
  components: {
    navi,
    foot,
    relevance
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      filterText: "",
      personDetail: {},
      phone: [],
      email: [],
      social: [],
      experience: [],
      educational: [],
      volunteeringexperiences: [],
      courses: [],
      projects: [],
      skills: [],
      certifications: [],
      honors: [],
      patents: [],
      publication: [],
      languages: [],
      dehashed: [],
      endorsors: [],
      defaultImg:
        'this.src="' + require("../../static/images/defult_head.png") + '"',
      facebook: {},
      gaoLiangKeyword: "",
      relevanceOne: true,
      relevanceTwo: false,
      activeName: "first",
      imgHeight: 160,
      loading: true
    };
  },
  created() {
    this.searchDetail();
  },
  mounted() {
    this.imgHeight = this.$refs.myDiv.offsetHeight;
  },
  methods: {
    //搜索高亮
    brightenKeyword(val) {
      if (val && this.gaoLiangKeyword) {
        // 根据英文逗号分隔关键词
        const keywords = this.gaoLiangKeyword.split(",");
        // 遍历关键词数组，依次高亮匹配的内容
        keywords.forEach(keyword => {
          if (keyword.trim()) {
            const reg = new RegExp(keyword.trim(), "ig");
            val = val.replace(reg, match => {
              return `<span style="color: red; font-size: 15px;">${match}</span>`;
            });
          }
        });
        return val;
      }
      return val;
    },
    // 如果输入值是 "present"，则返回 "至今"
    checkExperienceValue(input) {
      if (input === "present") {
        return "至今";
      }
      // 否则返回原来的数值
      return input;
    },
    returnDate(str) {
      if (str == null || str == "") {
        return "";
      } else {
        let newStr = str.substring(0, str.indexOf("T"));
        return newStr;
      }
    },
    returnSocial(str) {
      if (str == null || str == "") {
        return "";
      } else if (str.indexOf("www") > 0) {
        let newStr = str.substring(str.indexOf(".") + 1, str.length);
        return newStr;
      } else {
        let newStr = str.substring(str.indexOf("twitter"), str.length);
        return newStr;
      }
    },
    relevanceOneFunction() {
      this.relevanceOne = true;
      this.relevanceTwo = false;
    },
    relevanceTwoFunction() {
      this.relevanceOne = false;
      this.relevanceTwo = true;
    },

    async searchDetail() {
      let reg = new RegExp("</b>", "g"); //g代表全部
      this.personDetail = await getPersonsByid({
        id: this.$route.query.personid
      });

      if (this.$route.query.where != undefined) {
        this.gaoLiangKeyword = this.$route.query.where;
      }

      // console.log("personDetail", this.personDetail);

      /* 背书人 */
      if (this.personDetail.endorsors.length > 0) {
        this.endorsors = this.personDetail.endorsors;
        // console.log("endorsors:"+this.personDetail.endorsors);
      }

      /* 电话 */
      if (this.personDetail.phone != null) {
        this.phone = JSON.parse(
          this.personDetail.phone.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("phone:",this.phone);
      }

      /* 邮箱 */
      if (this.personDetail.email != null) {
        this.email = JSON.parse(
          this.personDetail.email.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("email:",this.email);
      }

      /* 社交账号 */
      if (this.personDetail.social != null) {
        this.social = JSON.parse(
          this.personDetail.social.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("social:",this.social);
      }

      /* 工作经历 */
      if (this.personDetail.experience != null) {
        this.experience = JSON.parse(
          this.personDetail.experience.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("experience:"+this.experience);
      }

      /* 教育经历 */
      if (this.personDetail.educational != null) {
        this.educational = JSON.parse(
          this.personDetail.educational.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("educational:"+this.educational);
      }

      /* 志愿者经历 */
      if (this.personDetail.volunteeringexperiences != null) {
        this.volunteeringexperiences = JSON.parse(
          this.personDetail.volunteeringexperiences
            .replace(/<b>/g, "")
            .replace(reg, "")
        );
        // console.log("volunteeringexperiences:" + this.volunteeringexperiences);
      }

      /* courses 培训经历 */
      if (this.personDetail.courses != null) {
        this.courses = JSON.parse(
          this.personDetail.courses.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("courses:" + this.courses);
      }

      /* 技能 */
      if (this.personDetail.skills != null) {
        this.skills = JSON.parse(
          this.personDetail.skills.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log('skills:',this.educational);
      }

      /* 项目经历 */
      if (this.personDetail.projects != null) {
        this.projects = JSON.parse(
          this.personDetail.projects.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("projects:", this.projects);
      }

      /* 获得证书 */
      if (this.personDetail.certifications != null) {
        this.certifications = JSON.parse(
          this.personDetail.certifications.replace(/<b>/g, "").replace(reg, "")
        );
        //http://222.128.56.68:11366/#/rwxq?personid=352
        // console.log("certifications:", this.certifications);
      }

      /* 获得荣誉 */
      if (this.personDetail.honors != null) {
        this.honors = JSON.parse(
          this.personDetail.honors.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("honors:", this.honors);
      }

      /* 专利 */
      if (this.personDetail.patents != null) {
        this.patents = JSON.parse(
          this.personDetail.patents.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("patents:", this.patents);
      }

      /* 出版物 */
      if (this.personDetail.publication != null) {
        this.publication = JSON.parse(
          this.personDetail.publication.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("publication:", this.publication);
      }

      /* dehashed */
      if (this.personDetail.dehashed != null) {
        this.dehashed = JSON.parse(
          this.personDetail.dehashed.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("dehashed:", this.languages);
      }

      /* 掌握语言 */
      if (this.personDetail.languages != null) {
        this.languages = JSON.parse(
          this.personDetail.languages.replace(/<b>/g, "").replace(reg, "")
        );
        // console.log("languages:", this.languages);
      }
      this.loading = false;
    },

    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        // 先滚动到元素位置
        element.scrollIntoView({
          block: "start",
          inline: "nearest",
          behavior: "smooth"
        });
      }
    }
  }
};
</script>

<style>
.mannerLi {
  list-style-type: none;
  border: 1px solid #e7eaec;
  display: block;
  margin-bottom: 10px;
  padding: 10px 15px;
  position: relative;
}

.mannerLabel {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}

.label-default {
  background-color: #d1dade;
  color: #5e5e5e;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  text-shadow: none;
}

.label-info {
  background-color: #23c6c8;
  color: #ffffff;
}

.bjtp {
  overflow-x: hidden;
  min-height: 800px;
  background: linear-gradient(
    to bottom,
    #3f48cc 0%,
    #3f48cc 285px,
    #f0f8ff 285px,
    #f0f8ff 100%
  );
}

.relevanceOne {
  border-bottom: 3px solid #1ab394;
  border-radius: 2px;
  cursor: pointer;
  padding-bottom: 4px;
}

.relevanceTwo {
  cursor: pointer;
}

.kstop {
  font-size: 15px;
  font-weight: bold;
}

.huaTitle {
  line-height: 14px;
  display: inline-block;
  border: 1px solid rgb(90, 114, 235);
  padding: 2px 12px;
  border-radius: 11px;
  color: rgb(90, 114, 235);
  font-size: 12px;
}

.endorsor {
  display: flex;
  flex-wrap: wrap;
}

.endorsor > div {
  width: 200px;
  margin-left: 40px;
  margin-bottom: 10px;
}

.endorsor img {
  width: 150px;
  height: 150px;
  border-radius: 8px;
}

.clampThree {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
  white-space: normal !important;
}

.na_message {
  -webkit-text-size-adjust: 100%;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  font-family: "PingFangSC-Medium", "PingFangSC", STHeiti, MingLiu;
  letter-spacing: 0.7px;
  word-break: break-all;
  box-sizing: border-box;
  border: 0;
  vertical-align: baseline;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  float: left;
  margin-left: 20px;
  color: #404246;
  width: calc(100% - 518px);
}

.na_message > ul {
  -webkit-text-size-adjust: 100%;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #404246;
  font-family: "PingFangSC-Medium", "PingFangSC", STHeiti, MingLiu;
  letter-spacing: 0.7px;
  word-break: break-all;
  box-sizing: border-box;
  border: 0;
  vertical-align: baseline;
  margin-bottom: 0px !important;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  margin-top: 0;
  overflow: hidden;
}

.na_img > img {
  margin: 0;
  letter-spacing: 0.7px;
  word-break: break-all;
  box-sizing: border-box;
  display: inline-block;
  border: 0;
  vertical-align: middle;
  width: 123px;
  height: 141px;
}

.na_message > ul > li {
  -webkit-text-size-adjust: 100%;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  line-height: 1.42857143;
  font-family: "PingFangSC-Medium", "PingFangSC", STHeiti, MingLiu;
  letter-spacing: 0.7px;
  word-break: break-all;
  vertical-align: baseline;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  list-style: none;
  float: left;
  border-radius: 11px;
  border: 1px solid #5a72eb;
  font-size: 12px;
  font-weight: 400;
  color: #5a72eb;
  padding: 2px 12px;
  margin: 2px 10px 0px 0px;
  box-sizing: border-box;
}

.na_message > p {
  -webkit-text-size-adjust: 100%;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  line-height: 1.42857143;
  color: #404246;
  font-family: "PingFangSC-Medium", "PingFangSC", STHeiti, MingLiu;
  letter-spacing: 0.7px;
  word-break: break-all;
  box-sizing: border-box;
  border: 0;
  vertical-align: baseline;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: 100%;
  font-size: 16px;
  overflow: hidden;
  margin-top: 10px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.na_img {
  -webkit-text-size-adjust: 100%;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333333;
  font-family: "PingFangSC-Medium", "PingFangSC", STHeiti, MingLiu;
  letter-spacing: 0.7px;
  word-break: break-all;
  box-sizing: border-box;
  vertical-align: baseline;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  float: left;
  border: 1px solid #ececec;
}

.na_list {
  -webkit-text-size-adjust: 100%;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333333;
  font-family: "PingFangSC-Medium", "PingFangSC", STHeiti, MingLiu;
  letter-spacing: 0.7px;
  word-break: break-all;
  box-sizing: border-box;
  border: 0;
  vertical-align: baseline;
  margin: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  padding: 10px 0;
  overflow: hidden;
}

.opct_msg {
  -webkit-text-size-adjust: 100%;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333333;
  font-family: "PingFangSC-Medium", "PingFangSC", STHeiti, MingLiu;
  letter-spacing: 0.7px;
  word-break: break-all;
  box-sizing: border-box;
  border: 0;
  vertical-align: baseline;
  margin: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  padding: 20px 40px;
}

.opct_title {
  height: 50px;
  /* background: #f0f5e7; */
  border-radius: 4px;
  line-height: 50px;
  color: #3547cb;
  font-size: 16px;
  border: 1px solid;
}

.opct_title span {
  margin-left: 20px;
}

.option_content {
  width: calc(100% - 175px);
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  margin-top: 75px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.ulleft {
  position: fixed;
  top: 158px;
}

.option_item > li {
  cursor: pointer;
  line-height: 40px;
  margin-left: 20px;
  list-style: none;
}

.option_item {
  float: left;
  background: #ffffff;
  width: 160px;
  color: #404246;
  font-size: 16px;
  padding: 15px 0;
  border-radius: 4px;
  margin-right: 15px;
  margin-left: 100px;
}

.daohl {
  padding: 0 270px;
  margin-top: 100px;
}

.daohl1 {
  width: 50%;
  padding: 20px;

  border: 1px solid #d5dbe6;
}

.ryliebiao {
  width: 100%;
  margin-left: -150px;
  padding: 20px;
  border: 1px solid #d5dbe6;
}

.frinp input {
  width: 60%;
  height: 30px;
}

.zdry_label {
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/view/rwxq.vue